// extracted by mini-css-extract-plugin
export default {"tbcell":"Table_tbcell__-ZdwQ","edit":"Table_edit__LK3a1","link":"Table_link__M8oAl","mbutton":"Table_mbutton__gdNIW","active":"Table_active__zzQ-7"};